/* ヘッダー表示・非表示
---------------------------------------------- */
export const HEADER = {
  init: function () {
    const header = document.querySelector('.l-header')

    if (!header) return

    let lastScroll = 0
    const offset = 100

    // スクロールでヘッダー表示・非表示
    window.addEventListener('scroll', () => {
      // ハンバーガーメニュー表示中は常に表示
      if (document.body.classList.contains('is-gnav-open')) {
        header.classList.remove('is-hide')
        return
      }

      const currentScroll = window.pageYOffset

      // ページ最上部では表示
      if (currentScroll <= 0) {
        header.classList.remove('is-hide')
      }
      // offsetまでは表示
      else if (currentScroll < offset) {
        header.classList.remove('is-hide')
      }
      // 下スクロール
      else if (currentScroll > lastScroll) {
        header.classList.add('is-hide')
      }
      // 上スクロール
      else {
        header.classList.remove('is-hide')
      }

      lastScroll = currentScroll
    })

    // ===========================
    // メニュー外クリックで閉じる
    // ===========================
    const nav = document.querySelector('.l-header__nav')
    const switchBtn = document.querySelector('.js-gnav-switch')

    if (nav && switchBtn) {
      document.addEventListener('click', e => {
        // メニューが閉じているなら何もしない
        if (!document.body.classList.contains('is-gnav-open')) return

        // メニュー内をクリック
        if (nav.contains(e.target)) return

        // ハンバーガーボタンをクリック
        if (switchBtn.contains(e.target)) return

        // メニューを閉じる
        document.body.classList.remove('is-gnav-open')

        // ヘッダーは表示状態に戻す
        header.classList.remove('is-hide')
      })
    }
  },
}